import React, { ReactNode } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

interface IRobotenDnDProvider {
  children: ReactNode
}

/**
 * Pre-configured dnd provider, configured with HTML5 Backend
 * from react-dnd.
 */
const RobotenDnDProvider = ({ children }: IRobotenDnDProvider): JSX.Element => (
  <DndProvider backend={HTML5Backend}>
    {children}
  </DndProvider>
)

export default RobotenDnDProvider
